import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { DoctorSpecialityService } from '../doctor-speciality.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DoctorSpeciality } from '../idoctor-speciality';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-doctor-speciality-detail',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TablerIconsModule,
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './doctor-speciality-detail.component.html',
  styleUrl: './doctor-speciality-detail.component.scss'
})
export class DoctorSpecialityDetailComponent implements OnInit {
  DoctorSpecialityForm: FormGroup;
  isEdit: boolean;

  constructor(
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _doctorSpecialityService: DoctorSpecialityService,
    private dialogRef: MatDialogRef<DoctorSpecialityDetailComponent>,
    private translate: TranslateService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { Doctorspeciality: DoctorSpeciality, isEdit: boolean },
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.DoctorSpecialityForm = this._formBuilder.group({
      name: [this._data?.Doctorspeciality?.name, [Validators.required, Validators.maxLength(50)]],
      isDefault: [this._data?.Doctorspeciality?.isDefault || false]
    });
  }

  onSaveDoctorSpeciality() {
    if (this.DoctorSpecialityForm.invalid) {
      return;
    }

    const data = this.DoctorSpecialityForm.getRawValue();

    this._doctorSpecialityService.createSpeciality(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.SPECIALITY')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });

  }

  onUpdateDoctorSpeciality() {
    if (this.DoctorSpecialityForm.invalid) {
      return;
    }

    const DoctorSpeciality = {
      id: this._data?.Doctorspeciality?.id,
      ...this.DoctorSpecialityForm.getRawValue()
    }

    this._doctorSpecialityService.updateSpeciality(DoctorSpeciality).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.SPECIALITY')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  OnCloseDialog() {
    this.dialogRef.close();
  }

}
